module.exports = __webpack_public_path__ + "img/new_years.9e893ba6.jpg";